"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateCartPricesDto = exports.UpdatePricesByCategoriesDto = exports.UpdatePricesByProductsDto = exports.UpdateProductPriceDto = exports.CartPricingResultDto = exports.ByCategoriesResultDto = exports.ByProductsResultDto = exports.ProductPriceResultDto = exports.GetExtendedCartDto = exports.UsePromoCodesOnCartDto = exports.RemoveCartDiscountQueryDto = exports.SetCartDiscountsDto = exports.SetCartDiscountDto = exports.GetCartsFiltersDto = exports.ByOrganizationCartDto = exports.ByUserCartDto = exports.UpdateCartItemsDto = exports.AddCartItemsDto = exports.ClearCartDto = exports.CreateCartDto = exports.UpdateCartDto = exports.OrganizationCartDto = exports.CartDto = exports.SimpleCartDto = void 0;
const general_dto_1 = require("../../dto/general.dto");
const organization_dto_1 = require("../../organization/dto/organization.dto");
const user_dto_1 = require("../../user/dto/user.dto");
class SimpleCartDto extends organization_dto_1.OrganizationBaseEntityDto {
}
exports.SimpleCartDto = SimpleCartDto;
class CartDto extends SimpleCartDto {
}
exports.CartDto = CartDto;
class OrganizationCartDto extends CartDto {
}
exports.OrganizationCartDto = OrganizationCartDto;
class UpdateCartDto {
}
exports.UpdateCartDto = UpdateCartDto;
class CreateCartDto extends UpdateCartDto {
}
exports.CreateCartDto = CreateCartDto;
class ClearCartDto {
}
exports.ClearCartDto = ClearCartDto;
class AddCartItemsDto {
}
exports.AddCartItemsDto = AddCartItemsDto;
class UpdateCartItemsDto {
}
exports.UpdateCartItemsDto = UpdateCartItemsDto;
class ByUserCartDto extends user_dto_1.ByOrganizationAndUserDto {
}
exports.ByUserCartDto = ByUserCartDto;
class ByOrganizationCartDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.ByOrganizationCartDto = ByOrganizationCartDto;
class GetCartsFiltersDto extends general_dto_1.PaginationQuery {
}
exports.GetCartsFiltersDto = GetCartsFiltersDto;
class SetCartDiscountDto {
}
exports.SetCartDiscountDto = SetCartDiscountDto;
class SetCartDiscountsDto {
}
exports.SetCartDiscountsDto = SetCartDiscountsDto;
class RemoveCartDiscountQueryDto {
}
exports.RemoveCartDiscountQueryDto = RemoveCartDiscountQueryDto;
class UsePromoCodesOnCartDto {
}
exports.UsePromoCodesOnCartDto = UsePromoCodesOnCartDto;
class GetExtendedCartDto {
}
exports.GetExtendedCartDto = GetExtendedCartDto;
class ProductPriceResultDto {
}
exports.ProductPriceResultDto = ProductPriceResultDto;
class ByProductsResultDto {
}
exports.ByProductsResultDto = ByProductsResultDto;
class ByCategoriesResultDto {
}
exports.ByCategoriesResultDto = ByCategoriesResultDto;
class CartPricingResultDto {
}
exports.CartPricingResultDto = CartPricingResultDto;
class UpdateProductPriceDto {
}
exports.UpdateProductPriceDto = UpdateProductPriceDto;
class UpdatePricesByProductsDto {
}
exports.UpdatePricesByProductsDto = UpdatePricesByProductsDto;
class UpdatePricesByCategoriesDto {
}
exports.UpdatePricesByCategoriesDto = UpdatePricesByCategoriesDto;
class UpdateCartPricesDto {
}
exports.UpdateCartPricesDto = UpdateCartPricesDto;
//# sourceMappingURL=cart.dto.js.map